import React from "react";
import { BrowserRouter, Routes as RouterRoutes, Route } from "react-router-dom";
import ScrollToTop from "components/ScrollToTop";
import ErrorBoundary from "components/ErrorBoundary";
import NotFound from "pages/NotFound";
import UsersManagementHub from "./pages/users-management-hub";
import UsersCrudManagement from "./pages/users-crud-management";
import WorkshopsCrudManagement from "./pages/workshops-crud-management";
import MultiEntityCrudHub from "./pages/multi-entity-crud-hub";
import EmergencyServiceProvidersCrud from "./pages/emergency-service-providers-crud";
import ProductsCrudManagement from "./pages/products-crud-management";
import OrdersManagementInterface from "./pages/orders-management-interface";
import BannerAdsCrudManagement from "./pages/banner-ads-crud-management";
import PushNotificationsCrudManagement from "./pages/push-notifications-crud-management";
import UserCarsProfileManagement from "./pages/user-cars-profile-management";
import AdminLoginAuthentication from "./pages/admin-login-authentication";
import WorkshopsAgenciesManagementHub from "./pages/workshops-agencies-management-hub";
import EnhancedOrdersManagementInterface from "./pages/enhanced-orders-management-interface";
import GovernoratesAreasHierarchicalManagement from "./pages/governorates-areas-hierarchical-management";
import DiscountProductCrudManagment from "pages/discount-products-crud-management";
import TagsCrudManagent from "pages/tags-crud-managment";

const Routes = () => {
  return (
    <BrowserRouter>
      <ErrorBoundary>
        <ScrollToTop />
        <RouterRoutes>
          {/* Define your route here */}
          <Route path="/" element={<AdminLoginAuthentication />} />
          <Route
            path="/users-management-hub"
            element={<UsersManagementHub />}
          />
          <Route
            path="/users-crud-management"
            element={<UsersCrudManagement />}
          />
          <Route path="/workshops" element={<WorkshopsCrudManagement />} />
          <Route
            path="/multi-entity-crud-hub"
            element={<MultiEntityCrudHub />}
          />
          <Route
            path="/emergency-service-providers-crud"
            element={<EmergencyServiceProvidersCrud />}
          />
          <Route
            path="/products-crud-management"
            element={<ProductsCrudManagement />}
          />
          <Route
            path="/discount-products-crud-management"
            element={<DiscountProductCrudManagment />}
          />
          <Route
            path="/orders-management-interface"
            element={<OrdersManagementInterface />}
          />
          <Route
            path="/banner-ads-crud-management"
            element={<BannerAdsCrudManagement />}
          />
            <Route
            path="/tags-management"
            element={<TagsCrudManagent />}
          />
          <Route
            path="/notifications-management"
            element={<PushNotificationsCrudManagement />}
          />
          <Route
            path="/user-cars-profile-management"
            element={<UserCarsProfileManagement />}
          />
          <Route
            path="/admin-login-authentication"
            element={<AdminLoginAuthentication />}
          />
          <Route
            path="/workshops-agencies-management-hub"
            element={<WorkshopsAgenciesManagementHub />}
          />
          <Route
            path="/enhanced-orders-management-interface"
            element={<EnhancedOrdersManagementInterface />}
          />
          <Route
            path="/governorates-areas-hierarchical-management"
            element={<GovernoratesAreasHierarchicalManagement />}
          />
          <Route path="*" element={<NotFound />} />
        </RouterRoutes>
      </ErrorBoundary>
    </BrowserRouter>
  );
};

export default Routes;
